import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
// import ModalParcela from "./ModalParcela";
import { toast } from "react-toastify";

const TabelaExames = (props) => {
  const [modal, setModal] = useState(false);

  const [parcelaEditavel, setParcelaEditavel] = useState(null);
  const { id } = useParams();

  const toggle = () => setModal(!modal);

  const [data, setData] = useState({
    columns: [
      { label: "ID", field: "id_consulta", sort: "asc", width: 150 },
      { label: "Data", field: "data", sort: "asc", width: 150 },
      { label: "Hora", field: "hora", sort: "asc", width: 150 },
      { label: "Cliente", field: "cliente", sort: "asc", width: 150 },
      { label: "Médico", field: "medico", sort: "asc", width: 150 },
      { label: "Área", field: "area", sort: "asc", width: 150 },
      { label: "Serviço", field: "servico", sort: "asc", width: 150 },
      { label: "Status", field: "status", sort: "asc", width: 150 },
      { label: "Mensagem", field: "observacao", sort: "asc", width: 150 },
    ],
    rows: [],
  });

  const formatarData = (data) => {
    const date = new Date(data);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const getConsultas = () => {
    fetch(`${process.env.REACT_APP_API}/consultas/cliente/${id}`)
      .then((response) => response.json())
      .then((response) => {
        setData((data) => ({
          ...data,
          rows: response?.map((consulta) => ({
            // id_consulta: consulta.id_consulta,
            data: formatarData(consulta.data),
            hora: consulta.hora,
            cliente: consulta.cliente,
            medico: consulta.medico,
            area: consulta.area,
            servico: consulta.servico,
            status: consulta.status,
            observacao: consulta.message,
            clickEvent: () => {
              setParcelaEditavel(consulta);
              setModal(true);
            },
          })),
        }));
      });
  };

  useEffect(async () => {
    await getConsultas();
  }, []);

  const handleOnParcelaEdicao = (texto, type) => {
    if (type === "success") {
      toast.success(texto);
    } else {
      toast.error(texto);
    }
    getConsultas();
  };

  return (
    <>
      {/* <ModalParcela
        onParcelaEdicao={handleOnParcelaEdicao}
        ParcelaEditavel={parcelaEditavel}
        isOpen={modal}
        toggle={toggle}
      /> */}
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              {/* <Button color="primary" onClick={toggle}>
                Adicionar Parcela
              </Button> */}
              <MDBDataTable striped responsive bordered data={data} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TabelaExames;
